import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController,Platform,ModalController } from 'ionic-angular';
// import { Socket } from 'ng-socket-io';
import { Observable } from 'rxjs/Observable';
import { Storage } from '@ionic/storage'
import { ComandasProvider } from '../../providers/comandas/comandas'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { CajaProvider } from '../../providers/caja/caja'
import { MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO, GESTION_PEDIDOS_SALON } from "../../config/url.servicio"
import { Subscription } from 'rxjs';
import { CentroDeCostosProvider } from '../../providers/centro-de-costos/centro-de-costos';

@IonicPage()
@Component({
  selector: 'page-comandas',
  templateUrl: 'comandas.html',
  providers: [ AuthService ]
})
export class ComandasPage implements OnInit,OnDestroy {
  public datos = [];
  public datosReales = []
  datosRealesComparar = []
  usuario = '';
  dato = '';
  imageUrl:string='assets/imgs/nota.png';
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  timerVar;
  timerVal;
  intervalSubscription: Subscription;
  intervalSubscriptionSound: Subscription;
  sound: HTMLAudioElement;
  tiempoTranscurrido: number = 0;
  tiempoMostrado: string;
  listaCentroDeCostosGestion = []
  constructor(public navCtrl: NavController, public navParams: NavParams,
             public servicioComandas:ComandasProvider ,
              public servicioCompania:CompaniasProvider,
              public auth: AuthService,
              public storage:Storage,
              public servicio:CajaProvider,
              public alertControllers: AlertController,
              public platform: Platform,
              public modalControllers: ModalController,
              public centroDeCostosProvider: CentroDeCostosProvider,
              private cdRef: ChangeDetectorRef
            ) {

                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })


              this.startTimer()

            }


            startTiempoUpdater(datosRealesComparar: any) {
              // Obtener la fecha actual fuera del bucle forEach
              const fechaActual = new Date();

              datosRealesComparar.forEach((item, index) => {
                const fechaEspecifica = new Date(item.fecha); // Asegúrate de que la estructura de datos sea la correcta

                // Calcular la diferencia de tiempo tomando en cuenta la zona horaria
                //const diferencia = fechaActual.getTime() - fechaEspecifica.getTime();

                // Iniciar un intervalo para actualizar el tiempo transcurrido de este registro específico
                // const intervalId = setInterval(() => {
                  const fechaActual = new Date(); // Actualizar la fecha actual en cada intervalo

                  const diferencia = fechaActual.getTime() - fechaEspecifica.getTime();

                  let tiempoTranscurrido = Math.floor(diferencia / 1000);
                  tiempoTranscurrido -= 5 * 60 * 60; // Restar 5 horas en segundos
                  // ... (resto del código)

                  let pedidoNombre = ""
                  if(item.domicilio == "S") {
                    pedidoNombre = "Domicilio # "
                  } else if (item.numeromesa =="200") {
                    pedidoNombre = "Turno # "
                  } else {
                    pedidoNombre = "Mesa # "
                  }
                  let turnoNuevo = item.turno


                  // Actualizar la variable "tiempoMostrado" correspondiente a este registro específico
                  if (this.datos[index]) {
                    this.datos[index].tiempoMostrado = this.convertirSegundosAHorasMinutosSegundos(tiempoTranscurrido);
                    this.datos[index].pedidoNombre = pedidoNombre;
                    this.datos[index].turnoNuevo = turnoNuevo;
                    this.datos[index].nombreUsuario = item.nombreUsuario;

                  }

                  // Limpiar intervalo si el tiempo transcurrido es mayor a un límite determinado (opcional)
                  // if (tiempoTranscurrido > LIMITE_TIEMPO) {
                  //   clearInterval(intervalId);
                  // }
                // }, 1000); // Actualizar el contador cada segundo 60000 1000
              });
            }


            convertirSegundosAHorasMinutosSegundos(segundos: number): string {
              const horas = Math.floor(segundos / 3600);
              const minutos = Math.floor((segundos % 3600) / 60);
              const segundosRestantes = segundos % 60;

              if (horas === 0) {
                if (minutos === 0) {
                  return `${segundosRestantes} segundos`;
                } else {
                  return `${minutos} minutos y ${segundosRestantes} segundos`;
                }
              } else {
                if (minutos === 0 && segundosRestantes === 0) {
                  return `${horas} horas`;
                } else if (minutos === 0) {
                  return `${horas} horas y ${segundosRestantes} segundos`;
                } else if (segundosRestantes === 0) {
                  return `${horas} horas y ${minutos} minutos`;
                } else {
                  return `${horas} horas, ${minutos} minutos y ${segundosRestantes} segundos`;
                }
              }
            }

            ngOnInit() {
              this.sound = new Audio('https://s3.us-east-1.amazonaws.com/sancolombia.com/assets/sonido.mp3');
            }

                startTimer(){
                  this.intervalSubscription = Observable.interval(30000).subscribe( x => {
                    this.buscarComandas()
                })
              }

              startListening(item) {
                this.intervalSubscription = Observable.interval(1000).subscribe(() => {
                  this.sound.play();
                  item.alertaActiva = true;
                  this.updateData(item);

                    // Detener el sonido y desactivar la alerta después de 5 segundos
                    // setTimeout(() => {
                    //   this.sound.pause();
                    //   this.sound.currentTime = 0;
                    //   item.alertaActiva = false;
                    //   this.updateData(item);
                    // }, 30000); // 5000 milisegundos = 5 segundos

                });


              }





              updateData(item) {
                const index = this.datos.findIndex(dataItem => dataItem === item);
                if (index > -1) {
                  this.datos = [...this.datos.slice(0, index), item, ...this.datos.slice(index + 1)];
                }
              }



              agregarCerosIzquierda(numero: number, longitud: number): string {
                return ('0' + numero).slice(-longitud); // Asegurar longitud específica con ceros a la izquierda
              }


              imprimirMesero(codigo:any){

                // if(this.imprimir){
                  this.storage.get('companiasId').then((val) => {

                  this.servicioComandas.imprimirComandasMesas(codigo,val)
                  .subscribe((data)=>{
                    let dataJSON = JSON.parse(data['_body'])
                    let responseData = dataJSON.data[0]
                    this.reemprimirRecibo(responseData)
                  },
                   error=>{
                     console.log(error)
                   })
                  })
             }


             reemprimirRecibo(mensaje) {
              let recibo = ''


              if(MODO_DESCONECTADO){
                  for (let index:any = 0; index < mensaje.length; index++) {
                      recibo += mensaje[index]['reciboCaja'] + '\n'
                  }
              }else{
                  if(mensaje && mensaje[0]){
                      let mensajes = mensaje
                      for (let index:any = 0; index < mensajes.length; index++) {
                          recibo += mensajes[index]['reciboCaja'] + '\n'
                      }
                  }
              }


              // mandar a imprimir
              this.servicio.imprimirRecibo(recibo).subscribe(
                  res => {

                  },
                  err => {
                      // si hay errores y no pudo imprimir debe guardar el archivo o seleccionar otra impresora
                      if(this.platform.is('android') || this.platform.is('ios')){
                          // var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                          // mywindow.document.write('<html><head><title>venta</title>');
                          // mywindow.document.write('</head><body >');
                          // mywindow.document.write(recibo);
                          // mywindow.document.write('</body></html>');
                          // mywindow.document.close(); // necessary for IE >= 10
                          // mywindow.focus(); // necessary for IE >= 10*/
                          // mywindow.print();
                          // mywindow.close();
                          this.mostrarMensajeExito(' '+ recibo)
                      }else{
                          let alert = this.alertControllers.create({
                              title: '',
                              subTitle: recibo,
                              buttons: ['Cerrar']
                          });
                          alert.present();
                          // si hay errores imprimiendo
                          // var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                          // mywindow.document.write('<html><head><title>venta</title>');
                          // mywindow.document.write('</head><body >');
                          // mywindow.document.write(recibo);
                          // mywindow.document.write('</body></html>');
                          // mywindow.document.close(); // necessary for IE >= 10
                          // mywindow.focus(); // necessary for IE >= 10*/
                          // // mywindow.print();
                          // mywindow.close();
                      }

                  }
              )


          }


          mostrarMensajeExito(mensaje) {
            let alert = this.alertControllers.create({
              title: 'Registro generado con exito',
              subTitle: mensaje,
              buttons: ['Cerrar']
            });
            alert.present();
        }

  eliminarComanda(item:any){
    this.storage.get('companiasId').then((val) => {

    this.servicioComandas.actualizarGestionComandasCocina(item,val,'COCINA')
    .subscribe((item)=>{
      this.buscarComandas()
      this.datos = []
      // this.intervalSubscription.unsubscribe();
      this.cdRef.detectChanges();
    },(error)=>{
      this.buscarComandas()
      console.log(error)
    })
  })
  }

agruparComandas(data:any, queHago:string){
  this.datosReales = []
  this.datos = []
  if(queHago=='S'){
    let bodyResponse = JSON.parse(data['_body'])
    let datosRealesResponse = bodyResponse.data[0]
    this.datosReales = datosRealesResponse
  }else{
    let bodyResponse = JSON.parse(data['_body'])
    let datosRealesResponse = bodyResponse.data[0]
    this.datosReales = datosRealesResponse
  }

  let recorrer = this.datosReales.length
    let valorNuevo = []
    let existe = 0
    let dondeVa = 0
    let posicionActualizar = 0

      for(let i=0;i<this.datosReales.length;i++){

      let codigoConsultar = this.datosReales[i].codigo
      dondeVa++

  if(this.datosReales[i].codigo === codigoConsultar){
    existe = 1
            if(this.datos.length== 0){
              let valores = {
                cantidad : this.datosReales[i].cantidad,
                codigo: this.datosReales[i].codigo,
                nombreProducto: this.datosReales[i].nombreProducto,
                imagen: this.datosReales[i].imagen,
                color: this.datosReales[i].color,
                numeromesa:this.datosReales[i].numeromesa == '200' ? this.datosReales[i].turno : this.datosReales[i].numeromesa,
                comandasId: this.datosReales[i].comandasId,
                id: 0,
                primerNombre:this.datosReales[i].primerNombre,
                direccion:this.datosReales[i].direccion,
                descripcion:this.datosReales[i].descripcion
              }

              this.datos = [[{
                cantidad : this.datosReales[i].cantidad,
                codigo: this.datosReales[i].codigo,
                nombreProducto: this.datosReales[i].nombreProducto,
                imagen: this.datosReales[i].imagen,
                color: this.datosReales[i].color,
                numeromesa:this.datosReales[i].numeromesa == '200' ? this.datosReales[i].turno : this.datosReales[i].numeromesa,
                comandasId: this.datosReales[i].comandasId,
                id: 0,
                primerNombre:this.datosReales[i].primerNombre,
                direccion:this.datosReales[i].direccion,
                descripcion:this.datosReales[i].descripcion,
                nombreUsuario: this.datosReales[i].nombreUsuario
              }]]
          }else{
            let exists = 0
              let valorRealPosicion = 0
              let posicion = 0
              for(let y = 0; y < this.datos.length; y++ ){
                if(this.datos[y][0]['codigo'] == codigoConsultar  ){
                  exists =  1
                  valorRealPosicion = y
                }
              }
              if(exists !== 1){
                let posicionnueva = this.datos.length
                this.datos[posicionnueva] = [{
                  'cantidad' :  this.datosReales[i].cantidad,
                  'codigo' : this.datosReales[i].codigo,
                  'imagen': this.datosReales[i].imagen,
                  'id' : i,
                  'nombreProducto' : this.datosReales[i].nombreProducto,
                  'numeromesa':this.datosReales[i].numeromesa == '200' ? this.datosReales[i].turno : this.datosReales[i].numeromesa,
                  'color': this.datosReales[i].color,
                  'comandasId': this.datosReales[i].comandasId,
                  'primerNombre':this.datosReales[i].primerNombre,
                  'direccion':this.datosReales[i].direccion,
                  'descripcion':this.datosReales[i].descripcion,
                  'nombreUsuario': this.datosReales[i].nombreUsuario
              }]
            }else{
                this.datos[valorRealPosicion].push({
                  'cantidad' :  this.datosReales[i].cantidad,
                  'codigo' : this.datosReales[i].codigo,
                  'imagen': this.datosReales[i].imagen,
                  'id' : i,
                  'nombreProducto' : this.datosReales[i].nombreProducto,
                  'numeromesa':this.datosReales[i].numeromesa == '200' ? this.datosReales[i].turno : this.datosReales[i].numeromesa,
                  'color': this.datosReales[i].color,
                  'comandasId': this.datosReales[i].comandasId,
                  'primerNombre':this.datosReales[i].primerNombre,
                  'direccion':this.datosReales[i].direccion,
                  'descripcion':this.datosReales[i].descripcion,
                  'nombreUsuario': this.datosReales[i].nombreUsuario
                })
              }
            }
          }
        }
        // this.stopSound()

        this.datosReales = this.unificarProductosGestionados(this.datosReales)
        // const groupedData = this.datosReales.reduce((acc, current) => {
        //   // Verificar si el UUID ya está en el nuevo objeto
        //   if (!acc[current.Uuid]) {
        //     acc[current.Uuid] = current; // Si no está, agregarlo al nuevo objeto
        //   }
        //   return acc;
        // }, {});
        // const result = [];
        // for (const key in groupedData) {
        //   result.push(groupedData[key]);
        // }
        this.startTiempoUpdater(this.datosReales)
}
  ionViewDidLoad() {
    console.log('ionViewDidLoad ComandasPage');
  }

  ionViewWillEnter(){
    this.buscarComandas()
  }

  buscartime(){
    setTimeout(()=>{
      this.buscarComandas()
    },4000)
  }

  buscarComandas(){
    this.storage.get('companiasId').then(async (val)=>{
      let listaCentroDeCostosGestion = await this.centroDeCostosProvider.buscarCentroDeCostosGestionPorTipo(val,'COCINA').toPromise()
      let listaCentroDeCostosGestionResponse = JSON.parse(listaCentroDeCostosGestion['_body'])
      let centroDeCostosGestionId = listaCentroDeCostosGestionResponse.data[0][0].centroDeCostosGestionId
    this.servicioComandas.buscarSalonSinFacturarPorCompania(val,centroDeCostosGestionId)
      .subscribe((data)=>{
        this.agruparComandas(data,'S')
      },err =>{
        console.log(err)
      })
    })
  }
  // getMessages() {
  //   let observable = new Observable(observer => {
  //     this.socket.on('messages', (data) => {
  //       observer.next(data);
  //     });
  //   })
  //   return observable;
  // }
  ionViewWillLeave() {
    // this.socket.disconnect();
  }

  // valoresComanda(){
  //   let observable = new Observable(observer =>{
  //     this.socket.on('datos-comanda',(data)=>{
  //       observer.next(data)
  //     })
  //   })
  //   return observable
  // }

  editarComanda(item:any){
    item['queHago'] = "A",
    item['nombreTabla'] = "comandas",
    item['name'] = "dataDynamicCrud"
    item['color'] = "#006400"
    item['estado'] = "G"
    this.servicioComandas.actualizarComandas(item).subscribe((val)=>{
     this.buscarComandas()
    })
    this.enviarMensaje('comanda-generada',item)
    this.servicioComandas.genearNotificacionComandas("comanda gestionada","Pedido: " + item.codigo)
    .subscribe((data)=>{
    },error =>{
      console.log(error)
    })

  }

  cancelarComanda(item:any){

    item['queHago'] = "A",
    item['nombreTabla'] = "comandas",
    item['name'] = "dataDynamicCrud"
    item['color'] = "#FF0000"
    item['estado'] = "C"
    let codigo = item.codigo
    let mensaje = ` código comanda ${codigo}`
    this.servicioComandas.cancelarComandas(item).subscribe(()=>{
    // this.buscarComandas()
    })
    this.enviarMensaje('comanda-generada',item)
    this.servicioComandas.genearNotificacionComandas('Comanda cancelada',mensaje)
    .subscribe(()=>{},error=>{console.log('la genero')})
    // this.buscarComandas()
  }
  enviarMensaje(nombre:any,data:any) {
    // this.socket.emit(nombre, data);
  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }
  ngOnDestroy() {
    this.intervalSubscription.unsubscribe();
    if (this.intervalSubscriptionSound) {
      this.intervalSubscriptionSound.unsubscribe();
    }
    this.sound.pause();
    this.sound.currentTime = 0;
  }
  stopSound(item) {
    if (this.intervalSubscriptionSound) {
      this.intervalSubscriptionSound.unsubscribe();
    }
    this.sound.pause();
    this.sound.currentTime = 0;
    item.alertaActiva = false; // Desactivar la alerta después de detener el sonido
    this.updateData(item);
  }
  startSound(item) {
    this.startListening(item)
  }
  unificarProductosGestionados(listaUnificar: any) {
    const groupedProducts = listaUnificar.reduce((acc, curr) => {
      const key = `${curr.Uuid}`;
      if (!acc[key]) {
          acc[key] = { ...curr, cantidad: curr.cantidad };
      } else {
          acc[key].cantidad += curr.cantidad;
      }
      return acc;
  }, {});

  const resultadoArray = Object.keys(groupedProducts).map(key => groupedProducts[key]);
  return resultadoArray;
  }
}



// WEBPACK FOOTER //
// ./src/pages/comandas/comandas.ts